export const GET_CHAT_TAGS_STARTED = "GET_CHAT_TAGS_STARTED";
export const GET_CHAT_TAGS_SUCCESS = "GET_CHAT_TAGS_SUCCESS";
export const GET_CHAT_TAGS_FAILED = "GET_CHAT_TAGS_FAILED";

export const CREATE_CHAT_TAG_STARTED = "CREATE_CHAT_TAG_STARTED";
export const CREATE_CHAT_TAG_SUCCESS = "CREATE_CHAT_TAG_SUCCESS";
export const CREATE_CHAT_TAG_FAILED = "CREATE_CHAT_TAG_FAILED";

export const UPDATE_CHAT_TAG_STARTED = "UPDATE_CHAT_TAG_STARTED";
export const UPDATE_CHAT_TAG_SUCCESS = "UPDATE_CHAT_TAG_SUCCESS";
export const UPDATE_CHAT_TAG_FAILED = "UPDATE_CHAT_TAG_FAILED";

export const DELETE_CHAT_TAG_STARTED = "DELETE_CHAT_TAG_STARTED";
export const DELETE_CHAT_TAG_SUCCESS = "DELETE_CHAT_TAG_SUCCESS";
export const DELETE_CHAT_TAG_FAILED = "DELETE_CHAT_TAG_FAILED";

export const REORDER_CHAT_TAGS_STARTED = "REORDER_CHAT_TAGS_STARTED";
export const REORDER_CHAT_TAGS_SUCCESS = "REORDER_CHAT_TAGS_SUCCESS";
export const REORDER_CHAT_TAGS_FAILED = "REORDER_CHAT_TAGS_FAILED";
